export const BASE_URL = "https://sz9kisfls6.execute-api.eu-west-1.amazonaws.com/";
export const SIGNUP_URL = "api/v2/cognito/signup";
export const primaryColor = "#ee7050";
export const secondColor = "#f0b560";
export const thirdColor = "#3e798d";
export const GOOGLE_API_KEY = "AIzaSyDhIbrl2q-FxE7VlLz6PFdweXAaNtYrlf8";